import React, { useMemo } from 'react';
import DevicesList from '#component/shipment/overview/devices-list';
import {
  DevicesListContainer,
  DevicesListPreloader,
  StyledDivider,
  ErrorText
} from '#component/device/dashboard/styles-map';
import useDeviceData from './useDevicesData';

/**
 * Renders device info, metrics, events etc.
 * Fetches device info data.
 */

const DevicesListWrapper = props => {
  const { devices, account, closeList } = props;
  const uids = useMemo(() => devices.map(d => d.uid), [devices]);
  const { status, devices: fetchedDevices, error } = useDeviceData(uids);
  const loading = status !== 'succeeded';

  return (
    <DevicesListContainer>
      {loading ? (
        <DevicesListPreloader />
      ) : (
        error ? (
          <>
            <StyledDivider />
            <ErrorText>
              Cannot load more details...
            </ErrorText>
          </>
        ) : (
          <DevicesList
            account={account}
            // fetchedDevices are always a new object
            devices={devices.reduce((a, c) => {
              const n = fetchedDevices.find(f => c.id === f.id);
              if (n) {
                n.lastMetricSource = 'getYoungestMetrics';
                a.push(n);
              }
              return a;
            }, [])}
            closeList={closeList}
            uids={uids}
          />
        )
      )}
    </DevicesListContainer>
  );
};

export default DevicesListWrapper;
